module.exports = __webpack_public_path__ + "components/rewards/hike-and-ride/static/logo-d0f1a6c9c141b5a34a6e1bf9bc429034.jpg";